import { render, staticRenderFns } from "./InactiveFBMUsersModule.vue?vue&type=template&id=3e9631bb"
import script from "./InactiveFBMUsersModule.vue?vue&type=script&lang=js"
export * from "./InactiveFBMUsersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports